import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  CircularProgress,
  Typography,
  DialogContent,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

const ValidationCheck = (props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState({
    apiTerraformCheck: { success: null, data: null, error: null },
    SecurityGroupCheck: { success: null, data: null, error: null },
  });

  const handleClick = async () => {
    setOpen(true);
    setLoading(true);

    try {
      const [res2, res3] = await Promise.all([
        fetchApiTerraformCheck(),
        fetchSecurityGroupCheck(),
      ]);
      setResults({
        apiTerraformCheck: res2,
        SecurityGroupCheck: res3,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchApiRabbitMQ = async () => {
  //   return axios
  //     .get("/get/status/validation-checks?check=rabbitmq-connection")
  //     .then((response) => ({
  //       success: true,
  //       data: response.data.message,
  //       error: null,
  //     }))
  //     .catch((error) => ({ success: false, data: null, error: error.message }));
  // };

  const fetchApiTerraformCheck = async () => {
    return axios
      .get("/get/status/validation-checks?check=terraform-check")
      .then((response) => ({
        success: true,
        data: response.data.message,
        error: null,
      }))
      .catch((error) => ({ success: false, data: null, error: error.message }));
  };

  const fetchSecurityGroupCheck = async () => {
    return axios
      .get(
        `/get/status/cm-security-groups/validation-checks?cad_topology_job_uuid=${props.data.job_id}`
      )
      .then((response) => ({
        success: true,
        data: response.data.message,
        error: null,
      }))
      .catch((error) => ({ success: false, data: null, error: error.message }));
  };

  const handleClose = () => {
    const allChecksPassed =
      results.apiTerraformCheck.success &&
      results.SecurityGroupCheck.success;
    props.handleValidationCheck(props.data.job_id, allChecksPassed);
    setOpen(false);
  };

  useEffect(() => {
    handleClick();
  }, []);

  const allChecksPassed =
    results.apiTerraformCheck.success &&
    results.SecurityGroupCheck.success;

  return (
    <div style={{ textAlign: "center", alignItems: "center" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5">Validation Results</Typography>

        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </div>
      <DialogContent>
        {loading ? (
          <div style={{ marginTop: "30px" }}>
            <CircularProgress />
          </div>
        ) : (
          <div>
            {/* <Alert severity={results.apiRabbitMQ.success ? "success" : "error"}>
              Rabbit MQ Check:{" "}
              {results.apiRabbitMQ.success
                ? `Success: ${results.apiRabbitMQ.data}`
                : `Failed: ${results.apiRabbitMQ.error}`}
            </Alert> */}
            <Alert
              severity={results.apiTerraformCheck.success ? "success" : "error"}
            >
              Terraform Check:{" "}
              {results.apiTerraformCheck.success
                ? `Success: ${results.apiTerraformCheck.data}`
                : `Failed: ${results.apiTerraformCheck.error}`}
            </Alert>
            <Alert
              severity={
                results.SecurityGroupCheck.success ? "success" : "error"
              }
            >
              Security Group Check:{" "}
              {results.SecurityGroupCheck.success
                ? `Success: ${results.SecurityGroupCheck.data}`
                : `Failed: ${results.SecurityGroupCheck.error}`}
            </Alert>
            {!allChecksPassed && (
              <Alert severity="warning" style={{ marginTop: "20px" }}>
                Warning: Not all validation checks passed. Please review the
                errors.
              </Alert>
            )}
          </div>
        )}
      </DialogContent>
    </div>
  );
};

export default ValidationCheck;
